// extracted by mini-css-extract-plugin
export default {"func":"func__p5jzH","func__chip":"func__chip__AYjo5"};